<template>
  <div class="agWf" :key="workflow._id + '-' + reload">
    <b-card>
      <template slot="header">
        <span
        class="agWf-title"
        v-b-tooltip.hover
        :title="'Open ' + workflow.name"
        @click="title_click">{{workflow.name}}</span>
        <b-dropdown
          class="agDropdown"
          no-caret dropleft
          v-b-tooltip.hover
          title="Actions">
          <template slot="button-content">
            <fa icon="cog"/>
          </template>
          <b-dropdown-item v-if="isReadonly" href="#"  @click="editWfButton_click"><fa icon="eye"/>View</b-dropdown-item>
          <b-dropdown-item v-else href="#" @click="editWfButton_click"><fa icon="pen"/>Edit</b-dropdown-item>
          <b-dropdown-item href="#" :disabled="isReadonly" @click="copyWfButton_click"><fa icon="copy"/>Copy</b-dropdown-item>
          <b-dropdown-item href="#" :disabled="isReadonly" @click="exportWfButton_click"><fa icon="file-export"/>Export</b-dropdown-item>
          <b-dropdown-item href="#" :disabled="isReadonly" @click="summaryWfButton_click"><fa icon="book"/>Get Summary</b-dropdown-item>
          <b-dropdown-item href="#" class="danger" :disabled="isReadonly" @click="deleteWfButton_click"><fa icon="ban"/>Delete</b-dropdown-item>
        </b-dropdown>
      </template>
      <ag-toggle
          :on="workflow.enabled"
          :label="'Enabled:'"
          :labelPosition="'left'"
          :disabled="isReadonly"
          @toggled="enabledDisableWorkflow">
      </ag-toggle>
      <label>{{workflow.notes}}</label>
      <hr>
      <div style="width: 30%; float:left">
        <label class="agWf-label">Start Date:</label>
        <label class="agWf-value">{{startStr}}</label>
         <br>
        <label class="agWf-label">Schedule:</label>
        <label class="agWf-value">{{scheduleStr}}</label>
        <br>
        <label class="agWf-label">Frequency:</label>
        <label class="agWf-value">{{frequencyStr}}</label>
        <br>
        <label class="agWf-label">Last Edited Date:</label>
        <label class="agWf-value">{{lastEditedDateStr}}</label>
        <br>
        <label class="agWf-label">Last Edited User:</label>
        <label class="agWf-value">{{lastEditedUserStr}}</label>
      </div>
      <div style="width: 70%; text-align: left; float:right">
        <label class="agWf-label">Summary:</label>
        <label class="agWf-value">{{summary}}</label>
        <br>
        <label class="agWf-label">Input:</label>
        <label class="agWf-value">{{wfInput}}</label>
        <br>
        <label class="agWf-label">GeoInput:</label>
        <label class="agWf-value">{{wfGeoInput}}</label>
        <br>
        <label class="agWf-label">Functionality:</label>
        <label class="agWf-value">{{wfFunctionality}}</label>
      </div>
    </b-card>
  </div>
</template>





<script>

// components
import Toggle from "comp/ui/Toggle";

// modules
import Moment from "moment";


export default {
  name: "ag-workflow",
  components:{
      "ag-toggle": Toggle
  },
  props: {
    workflow: Object
  },
  data() {
    return {
      reload: 0
    };
  },
  computed: {

    isReadonly() {
      if(this.user.role == "readonly")
        return true;
      return false;
    },

    user() {
      return this.$store.state.userStore.user;
    },

    startStr() {
      var schedule = this.workflow.schedule;
      if(schedule && schedule.startDate) {
        var date = Moment(schedule.startDate).format("M/DD/YY");
        return date;
      }
      return "";
    },

    scheduleStr() {

      var schedule = this.workflow.schedule;
      if(schedule && schedule.days) {
        var scheduleStr = "";
        if(schedule.days[1])
          scheduleStr += "Mon/";
        if(schedule.days[2])
          scheduleStr += "Tue/";
        if(schedule.days[3])
          scheduleStr += "Wed/";
        if(schedule.days[4])
          scheduleStr += "Thu/";
          if(schedule.days[5])
          scheduleStr += "Fri/";
        if(schedule.days[6])
          scheduleStr += "Sat/";
        if(schedule.days[0])
          scheduleStr += "Sun/";

        if(scheduleStr.length > 0) {
          scheduleStr = scheduleStr.substring(0, scheduleStr.length - 1); // remove last / and add comma
        }
        else {
          scheduleStr = "(No active days)";
        }

        scheduleStr += ", ";

        if(!schedule.startTime && !schedule.endTime) {
          scheduleStr += "(no start or end time)";
          return scheduleStr;
        }

        if(schedule.startTime)
          scheduleStr += Moment(schedule.startTime).format("h:mm a");
        scheduleStr += " - ";
        if(schedule.endTime)
          scheduleStr += Moment(schedule.endTime).format("h:mm a");

        return scheduleStr;
      }
      return "";
    },

    frequencyStr() {
      var schedule = this.workflow.schedule;
      if(schedule && schedule.frequency) {
        return schedule.frequency + " minute(s)";
      }
      return "";
    },

    lastEditedDateStr() {
      return Moment(this.workflow.updatedAt).format("M/DD/YY h:mm A");
    },

    lastEditedUserStr() {
      if(!this.workflow.lastEditedUser)
        return "";
      return this.workflow.lastEditedUser;
    },
    summary() {
      if(!this.workflow.summary) {
        return "";
      }
      return this.workflow.summary.Summary;
    },
    wfInput() {
      if(!this.workflow.summary) {
        return "";
      }
      return this.workflow.summary["Input"];
    },
    wfGeoInput() {
      if(!this.workflow.summary) {
        return "";
      }
      return this.workflow.summary["GeoInput"];
    },
    wfFunctionality() {
      if(!this.workflow.summary) {
        return "";
      }
      return this.workflow.summary["Workflow Functionality"];
    }
  },

  methods: {

    // UI Events

    editWfButton_click() {
      this.$emit("editWorkflow", this.workflow);
    },

    copyWfButton_click() {
      this.$emit("copyWorkflow", this.workflow);
    },

    exportWfButton_click() {
      this.$emit("exportWorkflow", this.workflow);
    },

    deleteWfButton_click() {
      this.$emit("deleteWorkflow", this.workflow);
    },

    summaryWfButton_click() {
      this.$emit("summaryWorkflow", this.workflow);
    },

    title_click()
    {
      this.$emit("launchWorkflowEditor", this.workflow);
    },

    // emitted events

    enabledDisableWorkflow()
    {
        this.workflow.enabled = !this.workflow.enabled;
        this.$store.dispatch("wfStore/updateWorkflow", {workflow: this.workflow});
        this.reload++;
    }
  }
};
</script>






<style scoped lang="css">
.agWf {
  margin-bottom: 25px;
}

.agWf-ghost .card {
  background-color: rgba(0, 0, 0, 0.15);
}

.agWf .card {
  height: 100%;
  text-align: left;
}

.agWf .card-header {
  color: #4A797C;
  font-weight: bold;
  font-size: 18px;
  cursor: grab;
}

.agWf .card-header:active {
  cursor: grabbing;
}

.agWf-title {
    cursor: pointer;
}

.agWf-title:hover {
    opacity: 0.5;
}


.agWf .agDropdown {
  float: right;
}

.agWf-label {
  width: 150px;
  font-weight: bold;
}

.agWf .agToggle
{
  float: right;
}

</style>



// WEBPACK FOOTER //
// src/components/workflow/Workflow.vue